import {StorageSpaceModel, StorageTypeModel} from '../../entities/storage-space.model';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpApiService} from '../base/http-api.service';
import {ApiResponseModel} from '../../entities/api-response.model';


@Injectable({
    providedIn: 'root'
})

export class StorageTypeService {

    constructor(
        public httpApiService: HttpApiService,
    ) {

    }

    public get(uid): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('storage-types/view', {uid});
    }

    public set(storage: StorageTypeModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('storage-types/store', storage);
    }

    public delete(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpDelete('storage-types/destroy', { uid });
    }

}


